export default __webpack_public_path__ + "static/media/Level12.fd095e81.svg";